<template>
  <div id="moduleForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-text-field v-model="module.name" label="Name" :required="true" />
      <v-text-field
        v-model="module.logo_image"
        label="Logo Image"
        :required="false"
      />
      <v-text-field v-model="module.path" label="Path" :required="true" />
      <v-text-field v-model="module.icon" label="Icon" :required="true" />
      <v-text-field v-model="module.color" label="color" :required="true" />
      <v-text-field
        v-model="module.description"
        label="Description"
        :required="true"
      />

      <v-checkbox v-if="module.id" v-model="module.active" :value="true" :label="module.active ? 'Active':'Disabled'" />

      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack"> Back </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>
    
<script>
import { getModule } from "@/services/module";

import { mapActions } from "vuex";

import { deactivateAccountModule, activateAccountModule } from "@/services/module";

import { getAccountModules } from '@/services/module'


export default {
  props: ["id"],
  data() {
    return {
      loaded: false,
      valid: false,
      module: {
        relations: {},
        name: "",
        logo_image: "",
        path: "",
        icon: "",
        color: "",
        description: "",
        active: ""
      },
    };
  },
  created() {
    this.setInstance();
  },
  methods: {
    ...mapActions("module", ["createModule", "updateModule"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),

    async handleSubmit() {

      if (this.id) {
        let module = this.module;
        delete module.relations;

        this.updateModule(module)
          .then((response) => {
            console.log(response);

            //add or remove module from user's account
            this.updateAccountModule(this.module);

            this.addSuccessMessage("Module was updated successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating Module, please try again later"
            );
          });
      } else {
        let module = this.module;
        delete module.relations;

        this.createModule(module)
          .then((response) => {
            this.module = response.data;

            this.addSuccessMessage("Module was created successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error creating Module, please try again later"
            );
          });
      }

    },
    goBack() {
      this.$router.go(-1);
    },
    updateAccountModule(module){
      if(module.active){
        activateAccountModule(module.id);
      }
      else{
        deactivateAccountModule(module.id);
      }
    },
    setInstance() {
      if (this.id) {
        this.module.id = this.id;
        getModule(this.id).then(async (response) => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.module, property)
            ) {
              this.module[property] = instance[property];
            }
          }

          const accountModules = await getAccountModules().then( (resp) => {
            return resp.data.content;
          })
          const accountModuleIds = accountModules.map(m => m.id);
          this.module['active'] = accountModuleIds.includes(this.module.id);

          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {},
  },
  components: {},
};
</script>
